
import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BookingModal from '../home/components/BookingModal';

export default function AGBPage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onBookingClick={openBookingModal} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-12 lg:pt-40 lg:pb-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm text-[#042A60]/60 mb-4">
            Rechtliches
          </p>
          <h1 className="text-4xl lg:text-6xl text-[#042A60] mb-6 font-light">
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="text-base text-[#042A60]/80 leading-relaxed">
            Stand: Januar 2025
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 lg:py-16 px-6 lg:px-12 bg-white">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* §1 Geltungsbereich */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §1 Geltungsbereich
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") gelten für alle Verträge zwischen klar:ki, Götzlingstr. 45f, 4040 Pöstlingberg, Österreich (nachfolgend „Anbieter") und dem Kunden (nachfolgend „Kunde") über die Erbringung von Beratungs- und Dienstleistungen im Bereich Künstliche Intelligenz.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen des Kunden werden nur dann und insoweit Vertragsbestandteil, als der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Diese AGB gelten auch für alle zukünftigen Geschäftsbeziehungen, auch wenn sie nicht nochmals ausdrücklich vereinbart werden.
            </p>
          </div>

          {/* §2 Vertragsgegenstand */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §2 Vertragsgegenstand
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Der Anbieter erbringt Beratungs- und Implementierungsleistungen im Bereich Künstliche Intelligenz, insbesondere die Konzeption, Entwicklung und Einführung von KI-Assistenten für Unternehmen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Angebot bzw. der Leistungsbeschreibung, die Bestandteil des Vertrages wird.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Der Anbieter ist berechtigt, zur Erfüllung seiner vertraglichen Pflichten Dritte als Erfüllungsgehilfen einzusetzen.
            </p>
          </div>

          {/* §3 Vertragsschluss */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §3 Vertragsschluss
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Angebote des Anbieters sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich gekennzeichnet sind.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Der Vertrag kommt durch die schriftliche Auftragsbestätigung des Anbieters oder durch Beginn der Leistungserbringung zustande.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Mündliche Nebenabreden bedürfen zu ihrer Wirksamkeit der schriftlichen Bestätigung durch den Anbieter.
            </p>
          </div>

          {/* §4 Mitwirkungspflichten */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §4 Mitwirkungspflichten des Kunden
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Der Kunde ist verpflichtet, dem Anbieter alle für die Durchführung des Auftrags erforderlichen Informationen, Unterlagen und Zugänge rechtzeitig und vollständig zur Verfügung zu stellen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Der Kunde benennt einen Ansprechpartner, der für die Koordination und Abstimmung mit dem Anbieter verantwortlich ist und entscheidungsbefugt ist.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Verzögerungen, die durch nicht rechtzeitige oder unvollständige Mitwirkung des Kunden entstehen, gehen nicht zu Lasten des Anbieters. Dadurch entstehende Mehraufwände können dem Kunden in Rechnung gestellt werden.
            </p>
          </div>

          {/* §5 Vergütung */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §5 Vergütung und Zahlungsbedingungen
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Die Vergütung richtet sich nach dem jeweiligen Angebot. Alle Preise verstehen sich zuzüglich der gesetzlichen Umsatzsteuer.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zur Zahlung fällig.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (3) Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 9,2 Prozentpunkten über dem jeweiligen Basiszinssatz zu berechnen.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (4) Die Aufrechnung mit Gegenansprüchen des Kunden ist nur zulässig, wenn diese unbestritten oder rechtskräftig festgestellt sind.
            </p>
          </div>

          {/* §6 Gewährleistung */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §6 Gewährleistung
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Der Anbieter erbringt seine Leistungen mit der Sorgfalt eines ordentlichen Unternehmers und nach dem aktuellen Stand der Technik.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Mängel sind unverzüglich nach Entdeckung schriftlich anzuzeigen. Der Anbieter wird berechtigte Mängel innerhalb angemessener Frist beheben.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Die Gewährleistungsfrist beträgt 12 Monate ab Abnahme der Leistung.
            </p>
          </div>

          {/* §7 Haftung */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §7 Haftung
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Vorsatz und grobe Fahrlässigkeit.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten. Die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Eine weitergehende Haftung ist ausgeschlossen. Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
            </p>
          </div>

          {/* §8 Vertraulichkeit */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §8 Vertraulichkeit und Datenschutz
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit erlangten vertraulichen Informationen geheim zu halten und nur für die Zwecke des Vertrages zu verwenden.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Der Anbieter verarbeitet personenbezogene Daten des Kunden ausschließlich im Rahmen der geltenden Datenschutzgesetze, insbesondere der DSGVO.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (3) Die Vertraulichkeitsverpflichtung gilt auch nach Beendigung des Vertragsverhältnisses fort.
            </p>
          </div>

          {/* §9 Schlussbestimmungen */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              §9 Schlussbestimmungen
            </h2>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (1) Es gilt österreichisches Recht unter Ausschluss des UN-Kaufrechts.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (2) Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist Linz, Österreich.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed mb-4">
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
            </p>
            <p className="text-base text-[#042A60]/80 leading-relaxed">
              (4) Änderungen und Ergänzungen dieser AGB bedürfen der Schriftform.
            </p>
          </div>

          {/* Kontakt */}
          <div>
            <h2 className="text-2xl lg:text-3xl text-[#042A60] mb-6 font-light">
              Kontakt
            </h2>
            <div className="bg-[#F5F5F5] p-6">
              <p className="text-base text-[#042A60] font-medium mb-2">klar:ki</p>
              <p className="text-sm text-[#042A60]/80">Götzlingstr. 45f, 4040 Pöstlingberg</p>
              <p className="text-sm text-[#042A60]/80">Firmenbuchnummer: FN458427 h</p>
              <p className="text-sm text-[#042A60]/80">UID-Nr: ATU63379926</p>
              <p className="text-sm text-[#042A60]/80 mt-2">E-Mail: <a href="mailto:eva@klar-ki.at" className="text-[#0A6AF0] hover:underline">eva@klar-ki.at</a></p>
              <p className="text-sm text-[#042A60]/80">Telefon: <a href="tel:+4369911413141" className="text-[#0A6AF0] hover:underline">+43 69911413141</a></p>
            </div>
          </div>

        </div>
      </section>

      <Footer />
      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </div>
  );
}
